export function getStatusPrazo(item, registros = []) {
    const hoje = new Date();

    const dataFim = item?.dataFim ? new Date(item.dataFim) : null;
    const dataHomologado = item?.dataHomologado ? new Date(item.dataHomologado) : null;

    if (dataHomologado) {
        if (!dataFim) {
            return {
                label: 'Homologado',
                color: 'success',
            };
        }

        if (dataHomologado <= dataFim) {
            return {
                label: 'Homologado no prazo',
                color: 'success',
            };
        }

        return {
            label: 'Homologado com atraso',
            color: 'warning',
        };
    }

    if (!dataFim) {
        return {
            label: 'Sem prazo',
            color: 'default',
        };
    }

    if (hoje > dataFim) {
        return {
            label: 'Atrasado',
            color: 'error',
        };
    }

    if (!registros?.length) {
        return {
            label: 'Não iniciado',
            color: 'default',
        };
    }

    return {
        label: 'Em andamento',
        color: 'info',
    };
}
export function getResumoStatusItens(rows = []) {
    const resumo = {
        total: 0,
        naoIniciado: 0,
        emAndamento: 0,
        atrasado: 0,
        homologado: 0,
        homologadoNoPrazo: 0,
        homologadoComAtraso: 0,
        semPrazo: 0,
    };

    rows.forEach((item) => {
        const status = getStatusPrazo(item);

        resumo.total += 1;

        switch (status.label) {
            case 'Não iniciado':
                resumo.naoIniciado += 1;
                break;
            case 'Em andamento':
                resumo.emAndamento += 1;
                break;
            case 'Atrasado':
                resumo.atrasado += 1;
                break;
            case 'Homologado':
                resumo.homologado += 1;
                break;
            case 'Homologado no prazo':
                resumo.homologadoNoPrazo += 1;
                break;
            case 'Homologado com atraso':
                resumo.homologadoComAtraso += 1;
                break;
            case 'Sem prazo':
                resumo.semPrazo += 1;
                break;
            default:
                break;
        }
    });

    return resumo;
}
